import type {
  BooleanField,
  HierarchicalRulesetConfigField,
  ModifiedBooleanField
} from '@library/types/rulesets';
import { PrizepicksSwitch, RuleSwitch } from '@library/components/switches';
import { RulesetsContext } from '@bo-hooks/rulesets/useRulesetsContext';
import { useContext } from 'react';

export const StateManagement = () => {
  const {
    currentRuleset,
    modifiedFields,
    handleUpdateRulesetField,
    matchedAllowedRules
  } = useContext(RulesetsContext);

  const stateManagementFields: Array<{
    label: string;
    fieldName: HierarchicalRulesetConfigField;
  }> = [
    {
      label: 'Allow Deposits',
      fieldName: 'allow_deposits'
    },
    {
      label: 'Allow Withdrawals',
      fieldName: 'allow_withdrawals'
    }
  ];

  return (
    <div className="bg-soFresh-110 text-soClean-160 font-heebo flex h-1/2 w-full flex-col gap-4 rounded-md p-5">
      <span className="text-soClean-100 font-heebo text-lg">
        Status Management
      </span>

      {currentRuleset && matchedAllowedRules.size > 0 && (
        <div className="flex flex-col gap-4 text-sm">
          <div className="flex flex-row justify-between">
            <span>Is Enabled</span>
            <PrizepicksSwitch
              active={modifiedFields.active ?? currentRuleset.attributes.active}
              disabled={false}
              handleChange={(value) =>
                handleUpdateRulesetField({ fieldName: 'active', value })
              }
            />
          </div>
          {stateManagementFields.map((field) =>
            matchedAllowedRules.has(field.fieldName) ? (
              <div
                className="flex flex-row justify-between"
                key={field.fieldName}
              >
                <span>{field.label}</span>
                <RuleSwitch
                  initialValue={
                    currentRuleset.attributes[field.fieldName] as BooleanField
                  }
                  modifiedValue={
                    modifiedFields[field.fieldName] as ModifiedBooleanField
                  }
                  active={
                    (modifiedFields[field.fieldName]?.value as boolean) ??
                    currentRuleset.attributes[field.fieldName].value ??
                    currentRuleset.attributes[field.fieldName].ancestor?.value
                  }
                  disabled={false}
                  handleChange={(value) =>
                    handleUpdateRulesetField({
                      fieldName: field.fieldName,
                      type: 'boolean',
                      value
                    })
                  }
                />
              </div>
            ) : null
          )}
        </div>
      )}

      {!currentRuleset && <>Unable to load ruleset</>}
    </div>
  );
};
